export default __webpack_public_path__ + "static/media/Team.ffaa94fe.svg";